import { ProductIcon } from '@cfs-fixings/shared'
import { PropsWithChildren } from 'react'

type PanelTitleProps = PropsWithChildren

const PanelTitle = ({ children }: PanelTitleProps) => {
  return (
    <div className="px-3.5 flex text-gray-900 items-center">
      <ProductIcon className="w-[14px] h-[14px] mr-[6px]" />
      <h1 className="font-semibold text-[13px]">
        {children}
      </h1>
    </div>
  )
}

export default PanelTitle
